export const getMaxByProperty = (arr: any, attr: string): any =>
	arr.reduce((a: any, b: any) => {
		if (b[attr] > a[attr]) {
			return b;
		} else {
			return a;
		}
	}, arr[0]);
